/**
 * Mirrors `PlanScopeType` on the coupons backend. The `@spa/api` coupon contracts type
 * `plan_scope_type` as a plain number, so the members live here until the enum ships with them.
 *
 * `SpecificPlans` carries `trading_plan_id` and no plan type; `AllPlansOfType` carries
 * `trading_plan_type_id` and no plan id — the backend rejects a scope that sets both.
 */
export enum CouponPlanScopeTypeEnum {
    SpecificPlans = 0,
    AllPlansOfType = 1
}
